<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import AiReviews from '~/components/modal-windows/AiReviews.vue'
import { useAiReviewsStore } from '~/store/ai-reviews'

const aiReviewsStore = useAiReviewsStore()

async function openAiReviewsModalWindow (): Promise<void> {
  await useModal({ component: AiReviews }).open()
}
</script>

<template>
  <div
    v-if="aiReviewsStore.aiSummaryText && aiReviewsStore.aiTags.length"
    class="rounded-xl border border-solid border-[#404e5e14] bg-white md:flex"
  >
    <div
      class="
        flex flex-col justify-between border-b border-solid border-[#404e5e14] p-4
        md:w-1/2 md:border-b-0 md:border-r
      "
    >
      <div class="mb-4 flex items-center space-x-1.5">
        <SvgIcon class="text-main-green" name="outlined/format-quote" />
        <div class="font-medium">
          Мнение покупателей
        </div>
        <SvgIcon
          class="text-main-green hover:cursor-pointer hover:text-main-blue"
          name="outlined/help-outline"
          @click="openAiReviewsModalWindow"
        />
      </div>
      <div class="border-l-[3px] border-solid border-main-green pl-4">
        {{ aiReviewsStore.aiSummaryText }}
      </div>
    </div>
    <div class="flex flex-col justify-between p-4 md:w-1/2">
      <div class="mb-4 flex items-center space-x-1.5">
        <SvgIcon class="text-main-green" name="outlined/auto-awesome" />
        <div class="font-medium">
          Часто упоминают
        </div>
        <SvgIcon
          class="text-main-green hover:cursor-pointer hover:text-main-blue"
          name="outlined/help-outline"
          @click="openAiReviewsModalWindow"
        />
      </div>
      <div class="-m-0.5 flex flex-col flex-wrap items-start md:flex-row">
        <div
          v-for="({ sentiment, tag }, i) in aiReviewsStore.aiTags"
          :key="i"
          class="m-0.5 flex items-center space-x-1 rounded px-1.5 py-0.5"
          :class="{
            'bg-[#59ad3b14] text-main-green': sentiment === '+',
            'bg-[#404e5e0a] text-main-silver': sentiment === '-'
          }"
        >
          <SvgIcon
            v-if="['+', '-', 'negative', 'positive'].includes(sentiment)"
            :name="['+', 'positive'].includes(sentiment) ? 'outlined/thumb-up' : 'outlined/thumb-down'"
          />
          <div class="first-letter:uppercase">
            {{ tag }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
